<div class="animated fadeIn">

<div class="row">

    <div class="col-lg-12">
        <div class="card">
            
            <div class="card-body" style="min-height: 600px;">
             <!-- <h4 class="box-title">Pending Request </h4> -->
             <!--<a class="float-right rtbtn btn btn-primary" style="margin-top: -35px;" (click)="logout()">Logout</a>-->
              <br/>
              <div class="row form-group" >
                    <div class="col col-md-12">
                        <div class="card border border-success">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-md-2">
                                        <strong class="card-title">Pending Request</strong>
                                    </div>
                                    <div class="col col-md-2">
                                        <select name="dataType" id="dataType" class="form-control-sm form-control" [(ngModel)]="dataType">
                                            <option  value="">Select Type</option>
                                            <option value="Segment">Segment</option>
                                            <option value="Form">Form</option>   
                                            <option value="Financial Highlights">Financial Highlights</option>
                                            <option value="Gross & Net Statistics">Gross & Net Statistics</option>
                                            <option value="Data on Motor">Data on Motor</option>
                                            <option value="Reinsurance">Reinsurance</option>
                                            <option value="Large Loss">Large Loss</option>
                                            <option value="Flash">Flash</option>
                                            
                                        </select>
                                    </div>
                                    <div class="col col-md-2">
                                        <select name="fileYear" id="fileYear" [(ngModel)]="fileYear" class="form-control-sm form-control" *ngIf="dataType=='Segment' || dataType=='Flash' ">
                                            <option  value="">Select Year</option>
                                            <option value="{{yr}}" *ngFor="let yr of yearArr">{{yr}}</option>
                                        </select>
                                        <select name="filefYear" id="filefYear" [(ngModel)]="filefYear" class="form-control-sm form-control" *ngIf="dataType!='Segment' && dataType !=='Flash'">
                                            <option  value="">Select Year</option>
                                            <option  value="{{fyr}}" *ngFor="let fyr of yearfArr">{{fyr}}</option>
                                        </select>
                                    </div>
                                    <div class="col col-md-2" *ngIf="dataType!=''">
                                        <select name="selectMonth" id="selectMonth" [(ngModel)]="selectMonth" class="form-control-sm form-control" *ngIf="dataType=='Segment'  || dataType=='Flash'">
                                            <option value="">Please select</option>
                                            <option value="January">January</option>
                                            <option value="February">February</option>
                                            <option value="March">March</option>
                                            <option value="April">April</option>
                                            <option value="May">May</option>
                                            <option value="June">June</option>
                                            <option value="July">July</option>
                                            <option value="August">August</option>
                                            <option value="September">September</option>
                                            <option value="October">October</option>
                                            <option value="November">November</option> 
                                            <option value="December">December</option> 
                                        </select>
                                        <select name="fileQuarter" id="fileQuarter" [(ngModel)]="fileQuarter" class="form-control-sm form-control" *ngIf="dataType == 'Form' || dataType == 'Financial Highlights' || dataType == 'Data on Motor' || dataType == 'Reinsurance'">
                                            <option value="">Select Quarter</option>
                                            <option value="Q1">Q1</option>
                                            <option value="Q2">Q2</option>
                                            <option value="Q3">Q3</option>
                                            <option value="Q4">Q4</option>                                            
                                        </select>
                                    </div>
                                    <div class="col col-md-2">
                                        <select name="status" id="status" class="form-control-sm form-control" [(ngModel)]="status">
                                            <option  value="">All</option>
                                            <option value="0">Pending</option>
                                            <option value="1">Approved</option>   
                                            <option value="2">Rejected</option>   
                                        </select>
                                    </div>
                                    <div class="col col-md-2">
                                        <button type="submit" class="btn btn-primary btn-sm" (click)="searchPenReq(1)" >Search</button>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card-body" > 
                                <div class="row form-group">
                                    <div class="col col-md-2">
                                        <label for="dataType" class=" form-control-label">
                                            <strong>Data Type</strong>
                                        </label>
                                    </div>
                                    <div class="col col-md-2">
                                        <label for="year" class=" form-control-label">
                                            <strong>Year</strong>
                                        </label>
                                    </div>
                                    <div class="col col-md-2" *ngIf="dataType!=''">
                                        <label for="monthOrQuarter" class=" form-control-label">
                                            <strong *ngIf="dataType=='Segment'">Month</strong>
                                            <strong *ngIf="dataType == 'Form' || dataType == 'Financial Highlights' || dataType == 'Data on Motor' || dataType == 'Reinsurance'">Quarter</strong>
                                        </label>
                                    </div>
                                    <div class="col col-md-2">
                                        <label for="status" class=" form-control-label">
                                            <strong>Status</strong>
                                        </label>
                                    </div>
                                    <div class="col col-md-4">
                                        &nbsp;
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-2">
                                        <select name="dataType" id="dataType" class="form-control-sm form-control" [(ngModel)]="dataType">
                                            <option  value="">Select Type</option>
                                            <option value="Segment">Segment</option>
                                            <option value="Form">Form</option>   
                                            <option value="Financial Highlights">Financial Highlights</option>
                                            <option value="Gross & Net Statistics">Gross & Net Statistics</option>
                                            <option value="Data on Motor">Data on Motor</option>
                                            <option value="Reinsurance">Reinsurance</option>
                                            <option value="Large Loss">Large Loss</option>
                                        </select>
                                    </div>
                                    <div class="col col-md-2">
                                        <select name="fileYear" id="fileYear" [(ngModel)]="fileYear" class="form-control-sm form-control" *ngIf="dataType=='Segment'">
                                            <option  value="">Select Year</option>
                                            <option value="{{yr}}" *ngFor="let yr of yearArr">{{yr}}</option>
                                        </select>
                                        <select name="filefYear" id="filefYear" [(ngModel)]="filefYear" class="form-control-sm form-control" *ngIf="dataType!='Segment'">
                                            <option  value="">Select Year</option>
                                            <option  value="{{fyr}}" *ngFor="let fyr of yearfArr">{{fyr}}</option>
                                        </select>
                                    </div>
                                    <div class="col col-md-2" *ngIf="dataType!=''">
                                        <select name="selectMonth" id="selectMonth" [(ngModel)]="selectMonth" class="form-control-sm form-control" *ngIf="dataType=='Segment'">
                                            <option value="">Please select</option>
                                            <option value="January">January</option>
                                            <option value="February">February</option>
                                            <option value="March">March</option>
                                            <option value="April">April</option>
                                            <option value="May">May</option>
                                            <option value="June">June</option>
                                            <option value="July">July</option>
                                            <option value="August">August</option>
                                            <option value="September">September</option>
                                            <option value="October">October</option>
                                            <option value="November">November</option> 
                                            <option value="December">December</option> 
                                        </select>
                                        <select name="fileQuarter" id="fileQuarter" [(ngModel)]="fileQuarter" class="form-control-sm form-control" *ngIf="dataType == 'Form' || dataType == 'Financial Highlights' || dataType == 'Data on Motor' || dataType == 'Reinsurance'">
                                            <option value="">Select Quarter</option>
                                            <option value="Q1">Q1</option>
                                            <option value="Q2">Q2</option>
                                            <option value="Q3">Q3</option>
                                            <option value="Q4">Q4</option>                                            
                                        </select>
                                    </div>
                                    <div class="col col-md-2">
                                        <select name="status" id="status" class="form-control-sm form-control" [(ngModel)]="status">
                                            <option  value="">All</option>
                                            <option value="0">Pending</option>
                                            <option value="1">Approved</option>   
                                            <option value="2">Rejected</option>   
                                        </select>
                                    </div>
                                    <div class="col col-md-6">
                                        <button type="submit" class="btn btn-primary btn-sm" (click)="searchPenReq(1)" >Search</button>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
                                            <thead>
                                                <tr role="row">
                                                    <th >File Name</th>
                                                    <th >Year</th>
                                                    <th >Quarter</th>
                                                    <th >Month</th>
                                                    <th >Requestor</th>
                                                    <th >Company</th>
                                                    <th >Date</th>
                                                    <th >Comments</th>
                                                    <th >Status</th>
                                                    
                                                    
                                                </tr>
                                            </thead>
                                            <tbody> 
                                            <tr role="row" class="odd" *ngFor="let rd of reqData">
                                                <td>{{rd.fileName}}</td>
                                                <td>{{rd.year}}</td>
                                                <td>{{rd.quarter?rd.quarter:'N/A'}}</td>
                                                <td>{{rd.month?rd.month:'N/A'}}</td>
                                                <td>{{rd.RequestorEmail}}</td>
                                                <td>{{rd.companyName}}</td>
                                                <td>{{rd.create_date| date:'dd-MM-yyyy HH:mm:ss'}}</td>
                                                <td>{{rd.requestComments}}</td>
                                                <td><span *ngIf="rd.status==0">Pending</span><span *ngIf="rd.status==1">Approved</span><span *ngIf="rd.status==2">Rejected</span></td>
                                                
                                            </tr> 
                                            <!--<tr role="row" class="odd" *ngIf="haveData">
                                                <td colspan="5"> NO DATA FOUND
                                               </td>
                                            </tr> -->
                                            
                                        </tbody>
                                        </table>
            </div>
        </div>
       <div class="row">
                <div class="col-sm-12 col-md-5">
                    <div class="dataTables_info" id="bootstrap-data-table_info" role="status" aria-live="polite">Showing {{(curPage-1)*perPageRow+1}} to {{(curPage-1)*perPageRow+noOfRows}} of {{totalRows}}</div>
                </div>
                <div class="col-sm-12 col-md-7">
                    <div class="dataTables_paginate paging_simple_numbers" id="bootstrap-data-table_paginate">
                        <ul class="pagination">
                           <!-- <li class="paginate_button page-item previous disabled" id="bootstrap-data-table_previous" (click)="searchFile(curPage-1)" *ngIf="curPage==1">
                                <a  aria-controls="bootstrap-data-table" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
                            </li>-->
                            
                            <li class="paginate_button page-item {{item==curPage?'active':''}}" *ngFor="let item of pages; let i = index" (click)="searchPenReq(item)">
                                <a  aria-controls="bootstrap-data-table"  class="page-link">{{item}}</a>
                            </li>
                            <!--<li class="paginate_button page-item next" id="bootstrap-data-table_next" (click)="searchFile(curPage-1)" >
                                <a  aria-controls="bootstrap-data-table" data-dt-idx="7" tabindex="0" class="page-link">Next</a>
                            </li>-->
                        </ul>
                    </div>
                </div>
            </div>
        </div>


</div>
</div><!-- .animated -->

